var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label"},[_c('label',{attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.info))])])}
var staticRenderFns = []

export { render, staticRenderFns }